import React, { Component } from 'react';
import '../App.css';
import { Panel } from 'react-bootstrap';
import Wiktionary from '../Engines/Wiktionary.js';
import WikipediaENG from '../Engines/WikipediaENG.js';
import Description from './Description.js';

const engines = new Map();

//Description of this group.
//This is what user will see by pressing the info icon.
const description = (
  <div>
    {/* <strong>Wiktionary</strong> displays matches from your query to words in multiple languages
    listed in the Wiktionary. Vulqar words are highlighted in red.
    <br />  <br /> */}
    <strong>Wikipedia</strong> shows search results with your query from the
    Wikipedia.
  </div>
)

class Wiki extends Component {
  constructor () {
    super();
    // engines.set("Wiktionary", {});
    engines.set("Wikipedia Englanti", {});
    this.state = {
      resultCount: 0,
      open: true,
      noSearches: true,
    };
  }

  clear(){
    // engines.set("Wiktionary", {});
    engines.set("Wikipedia Englanti", {});
    this.setState({
      resultCount: 0,
      open: true,
    });
  }

  addResult(source, content, searchQuery) {
    if (engines.has(source)) {
      engines.set(source, content)
      this.setState({
        resultCount: this.state.resultCount + 1,
        noSearches: false
      });
    }
  }

  handleClick() {
    this.setState({open: !this.state.open});
  }

  header(){
    return(
      <div className="resultBox__header" onClick={ ()=> this.setState({ open: !this.state.open })}>
        <h3 className="resultBox__title">Wiki Results</h3>
      </div>
    );
  }

  render() {
      return (

        <Panel className="resultBox" collapsible expanded={this.state.open} header={this.header()}>
          <div className="resultBox__content  clearfix">
            <div className="Description wiki-desc">
              {description}
            </div>
            {/* <div className="WikiDiv">
              <Wiktionary content={engines.get("Wiktionary")}/>
            </div> */}
            <div className="WikiDiv">
              <WikipediaENG content={engines.get("Wikipedia Englanti")}/>
            </div>
          </div>
          <div className="resultBox__footer"></div>
          
        </Panel>
      );
  }
}

export default Wiki;



// WEBPACK FOOTER //
// ./client/src/Groups/Wiki.js